import {NgModule} from '@angular/core';
import {FileUploadComponent} from "./components/file-upload/file-upload.component";
import {NgxDropzoneModule} from "ngx-dropzone";
import {MatIconModule} from "@angular/material/icon";
import {NgForOf, NgIf, NgStyle} from "@angular/common";
import {NotFoundComponent} from './components/not-found/not-found..component';
import {ConfirmationDialogComponent} from "./components/confirmation-dialog/confirmation-dialog.component";
import {SaveQuoteChangesDialogComponent} from "./components/save-quote-changes-dialog/save-quote-changes-dialog.component";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {TimeFormatPipe} from "./pipes/time-format.pipe";
import {ProjectFileUploadComponent} from './components/project-file-upload/project-file-upload.component';
import {MatExpansionModule} from '@angular/material/expansion';

@NgModule({
	declarations: [
    FileUploadComponent,
    NotFoundComponent,
    ConfirmationDialogComponent,
    TimeFormatPipe,
    SaveQuoteChangesDialogComponent,
    ProjectFileUploadComponent
	],
	exports: [
    FileUploadComponent,
    ConfirmationDialogComponent,
    SaveQuoteChangesDialogComponent,
    ProjectFileUploadComponent,
    TimeFormatPipe
	],
  imports: [
    NgxDropzoneModule,
    MatIconModule,
    NgForOf,
    MatDialogModule,
    MatButtonModule,
    MatExpansionModule,
    NgStyle,
    NgIf
  ],
	providers: []
})
export class SharedModule {}
